var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container d-flex justify-content-center align-items-center"},[_c('div',[_c('span',[_vm._v("Copyright © 2026 Etilang Kemenhub")])])])])
}]

export { render, staticRenderFns }